export const MODALS_SLICE = "modals";

export const MODAL_TYPES = {
  LOGIN: "login",
  SIGNUP: "signup",
  INTERESTS: "interests",
  NONE: null,
};
